var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9982 10.5C4.9982 11.328 5.6687 12 6.4982 12C7.3277 12 7.9982 11.328 7.9982 10.5V7.5009H11C11.8295 7.5009 12.5 6.8289 12.5 6.0009C12.5 5.1729 11.8295 4.5009 11 4.5009H7.9982V1.5C7.9982 0.672 7.3277 0 6.4982 0C5.6687 0 4.9982 0.672 4.9982 1.5V4.5009H2C1.1705 4.5009 0.5 5.1729 0.5 6.0009C0.5 6.8289 1.1705 7.5009 2 7.5009H4.9982V10.5Z",
    fill: "#6F47EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4f3880f4630f41aa84994bfcf8599dc9.svg";
export { ForwardRef as ReactComponent };